import React from 'react';
import { ChevronRight, TrendingUp } from 'lucide-react';
import { AIOutlineButton } from '../ui/AIOutlineButton';
interface Recommendation {
  id: string;
  title: string;
  type: string;
  diamondRange: string;
  reason: string;
  ctaLabel: string;
  onCtaClick: () => void;
}
interface AIRecommendationPanelProps {
  recommendations: Recommendation[];
  title?: string;
  lastUpdated?: string;
}
export const AIRecommendationPanel: React.FC<AIRecommendationPanelProps> = ({
  recommendations,
  title = 'Suggerimenti AI',
  lastUpdated = 'Ultimi 30 giorni'
}) => {
  if (!recommendations || !Array.isArray(recommendations)) {
    return <div className="space-y-4" data-id="element-160">
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-161">
          <p className="text-sm text-gray-500" data-id="element-162">
            Nessun suggerimento disponibile al momento.
          </p>
        </div>
      </div>;
  }
  return <div className="space-y-4" data-id="element-163">
      {/* Cards suggerimenti */}
      {recommendations.slice(0, 2).map(rec => <div key={rec.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:border-gray-300 transition-colors" data-id="element-164">
          <div className="flex items-start justify-between mb-2" data-id="element-165">
            <div className="flex-1" data-id="element-166">
              <div className="mb-2" data-id="element-167">
                <h4 className="font-medium text-gray-900" data-id="element-168">{rec.title}</h4>
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-500 mb-2" data-id="element-169">
                <TrendingUp className="h-3 w-3" data-id="element-170" />
                <span data-id="element-171">{rec.diamondRange}</span>
              </div>
              <p className="text-sm text-gray-600" data-id="element-172">{rec.reason}</p>
            </div>
          </div>
          {/* CTA Button */}
          <div className="inline-block mt-3" data-id="element-173">
            <AIOutlineButton onClick={rec.onCtaClick} className="text-xs px-3 py-1.5" data-id="element-174">
              <span className="flex items-center gap-1" data-id="element-175">
                {rec.ctaLabel}
                <ChevronRight className="h-3.5 w-3.5" data-id="element-176" />
              </span>
            </AIOutlineButton>
          </div>
        </div>)}
      {/* Privacy notice */}
      <div className="pt-4 border-t border-gray-200" data-id="element-177">
        <p className="text-xs text-gray-400" data-id="element-178">
          Basato su dati aggregati. Nessun dato personale.
        </p>
      </div>
    </div>;
};